<template>
<div id="app" class="container-fluid">
  <div id="loader" v-show="loading">
    <img src="/static/img/loader.gif" alt="">
  </div>
  <top-header v-if="authenticated"></top-header>
  <div class="row">
    <div :class="sidebarClasses" v-if="authenticated">
      <sidebar></sidebar>
    </div>
    <div :class="containerClasses">
      <router-view></router-view>
    </div>
  </div>
</div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import TopHeader from './components/TopHeader.vue'
import auth from './auth'
import store from './store'

export default {
  name: 'App',
  data () {
    return store.state
  },
  components: {
    Sidebar,
    TopHeader
  },
  computed: {
    authenticated () {
      return auth.hasToken()
    },
    containerClasses () {
      if (!this.authenticated) {
        return {'col-sm-12': true}
      }
      if (this.menu) {
        return {'col-sm-10': true}
      }
      return { 'col-sm-12': true }
    },
    sidebarClasses () {
      if (this.menu) {
        return {'col-sm-2': true}
      }
      return {'hidden': true}
    }
  }
}
</script>

<style lang="less" type="text/less">
@import '../node_modules/bootstrap/less/bootstrap.less';
@import './variables.less';
@import 'theme.less';
</style>



// WEBPACK FOOTER //
// App.vue?139f8256